import { render, staticRenderFns } from "./ListViewTemplates.vue?vue&type=template&id=36b07987&"
import script from "./ListViewTemplates.vue?vue&type=script&lang=js&"
export * from "./ListViewTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports